import routeConfig from 'edge/fnol/ho/config/RouteConfig';
import 'edge/fnol/common/app';

export default angular.module('edge.fnol.ho.app', ['edge.fnol.common.app']).config(['$stateProvider', 'state_plugin_config', function ($stateProvider, RootStateConfig) {
    var states = routeConfig(RootStateConfig);
    for (var stateName in states) {
        if (states.hasOwnProperty(stateName)) {
            $stateProvider.state(stateName, states[stateName]);
        }
    }
}]);